import { useEffect } from 'react';
import ProjectReview from '~/features/projectReview';
import { Route, Switch, useParams } from 'react-router-dom';
import { ProjectContextProvider } from '~/hooks/providers/ProjectContextProvider';
import ProjectWorksheet from '~/features/projectWizard/worksheets/project';
import Dataroom from '~/features/dataroom';
import ProjectPage from '~/components/ProjectPage';
import { DataroomProvider } from '~/features/dataroom/providers/DataroomProvider';
import RedirectRoute from './RedirectRoute';
import Messaging from '~/features/messaging';
import { MessagingProvider } from '~/features/messaging/providers/MessagingProvider';
import { ConversationProvider } from '~/features/messaging/providers/ConversationProvider';
import TeamManagement from '~/components/TeamManagement';
import { validation } from '~/schema/project';
import ProjectBidding from '~/features/projectBidding/developer';
import { MarketplaceControls } from '~/features/marketplace/admin/MarketplaceControls';
import { usePermissions } from '~/requests/permissions/usePermissions';
import MarketplaceReview from '~/features/marketplace/MarketplaceReview';
import { logUserActivity, UserActivityTypes } from '~/api/user';
import DocumentIngestion from '~/features/documentIngestion';
import { DocumentIngestionProgressProvider } from '~/features/documentIngestion/DocumentIngestionProgressProvider';

function Project() {
  const { id } = useParams() as any;
  const { permissions } = usePermissions();

  useEffect(() => {
    if (id) {
      logUserActivity({ activityType: UserActivityTypes.PROJECT_VIEW, projectId: id });
    }
  }, [id]);


  return (
    <ProjectContextProvider id={id} validation={validation}>
      <DocumentIngestionProgressProvider>
      <ProjectPage>
        <Switch>
          <Route path="/project/:id/review">
            <ProjectReview />
          </Route>
          <Route path="/project/:id/bidding">
            <ProjectBidding />
          </Route>
          <Route path="/project/:id/ingestion">
            <DocumentIngestion />
          </Route>
          <Route path="/project/:id/worksheet">
            {permissions?.hasProjectInvestorAccess && !permissions?.isAdmin ? (
              <RedirectRoute to={`/project/${id}/review`} />
            ) : (
              <ProjectWorksheet />
            )}
          </Route>
          <Route exact path="/project/:id/dataroom">
            <Route exact path="/project/:id/dataroom">
              <DataroomProvider>
                <div className="card">
                  <Dataroom />
                </div>
              </DataroomProvider>
            </Route>
          </Route>
          <Route exact path="/project/:id">
            <RedirectRoute to={`/project/${id}/review`} />
          </Route>
          <Route exact path="/project/:id/messages">
            <ConversationProvider>
              <MessagingProvider pageType="project">
                <div className="card">
                  <Messaging />
                </div>
              </MessagingProvider>
            </ConversationProvider>
          </Route>
          <Route exact path="/project/:id/team">
            <div className="card">
              <TeamManagement />
            </div>
          </Route>
          <Route exact path="/project/:id/listing">
            <div className="card">
              {permissions.isAdmin ? (
                <MarketplaceControls projectId={id} />
              ) : permissions.isDeveloper ? (
                <MarketplaceReview projectId={id} />
              ) :
                <RedirectRoute to={`/project/${id}/review`} />
              }
            </div>
          </Route>
        </Switch>
      </ProjectPage>
      </DocumentIngestionProgressProvider>
    </ProjectContextProvider>
  );
}

export default Project;
